<mat-form-field>
    <mat-label>{{placeholder | blah}}</mat-label>
    <input matInput
        name="keyword"
        [value]="keyword"
        (input)="onChange($event.target.value)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (keyup.enter)="onEnter()" />
    <mat-icon matPrefix>search</mat-icon>
    @if (keyword) {
        <button matSuffix
            mat-icon-button
            (click)="onChange('')">
            <mat-icon>close</mat-icon>
        </button>
    }
</mat-form-field>